import { SideNavOptions } from "containers";
import { useAxios } from "common/axios";
import { useLoginContext } from "common/context";
import React from "react";
import { Container } from "./styles";

const SYNC_USER = "shulem@hbamfl.com";

const LandingPage = () => {
  const { currentUser } = useLoginContext();
  const { callAxios, loading } = useAxios({
    alertSuccess: "Sync started successfully",
    alertError: true,
  });

  const handleSync = () => {
    callAxios({ url: "/crons/sync", method: "POST" });
  };

  return (
    <Container>
      <h1>Welcome Back</h1>
      <h3>Select an Option</h3>
      <SideNavOptions responsive />
      {currentUser?.email === SYNC_USER && (
        <button
          onClick={handleSync}
          disabled={loading}
          style={{ marginTop: "24px" }}
        >
          {loading ? "Syncing..." : "Sync"}
        </button>
      )}
    </Container>
  );
};

export default LandingPage;
